import * as types from './redux.actionTypes';

// Template Actions
export const fetchTemplates = () => ({
    type: types.FETCH_TEMPLATES
});

export const fetchTemplatesSuccess = (data) => ({
    type: types.FETCH_TEMPLATES_SUCCESS,
    payload: data
});

export const fetchTemplatesFailure = (error) => ({
    type: types.FETCH_TEMPLATES_FAILURE,
    payload: error
});

export const fetchTemplateWithGoals = (templateId) => ({
    type: types.FETCH_TEMPLATE_WITH_GOALS,
    payload: templateId
});

export const fetchTemplateWithGoalsSuccess = (data) => ({
    type: types.FETCH_TEMPLATE_WITH_GOALS_SUCCESS,
    payload: data
});

export const fetchTemplateWithGoalsFailure = (error) => ({
    type: types.FETCH_TEMPLATE_WITH_GOALS_FAILURE,
    payload: error
});

export const createTemplate = (data) => ({
    type: types.CREATE_TEMPLATE,
    payload: data
});

export const createTemplateSuccess = (data) => ({
    type: types.CREATE_TEMPLATE_SUCCESS,
    payload: data
});

export const createTemplateFailure = (error) => ({
    type: types.CREATE_TEMPLATE_FAILURE,
    payload: error
});

export const updateTemplate = (templateId, data) => ({
    type: types.UPDATE_TEMPLATE,
    payload: { templateId, data }
});

export const updateTemplateSuccess = (data) => ({
    type: types.UPDATE_TEMPLATE_SUCCESS,
    payload: data
});

export const updateTemplateFailure = (error) => ({
    type: types.UPDATE_TEMPLATE_FAILURE,
    payload: error
});

export const deleteTemplate = (templateId) => ({
    type: types.DELETE_TEMPLATE,
    payload: templateId
});

export const deleteTemplateSuccess = (templateId) => ({
    type: types.DELETE_TEMPLATE_SUCCESS,
    payload: templateId
});

export const deleteTemplateFailure = (error) => ({
    type: types.DELETE_TEMPLATE_FAILURE,
    payload: error
});

// Goal Management Actions
export const fetchAllGoals = () => ({
    type: types.FETCH_ALL_GOALS
});

export const fetchAllGoalsSuccess = (data) => ({
    type: types.FETCH_ALL_GOALS_SUCCESS,
    payload: data
});

export const fetchAllGoalsFailure = (error) => ({
    type: types.FETCH_ALL_GOALS_FAILURE,
    payload: error
});

// Department Actions
export const fetchDepartments = () => ({
    type: types.FETCH_DEPARTMENTS
});

export const fetchDepartmentsSuccess = (data) => ({
    type: types.FETCH_DEPARTMENTS_SUCCESS,
    payload: data
});

export const fetchDepartmentsFailure = (error) => ({
    type: types.FETCH_DEPARTMENTS_FAILURE,
    payload: error
});

export const addGoalToTemplate = (templateId, goalData) => ({
    type: types.ADD_GOAL_TO_TEMPLATE,
    payload: { templateId, goalData }
});

export const addGoalToTemplateSuccess = () => ({
    type: types.ADD_GOAL_TO_TEMPLATE_SUCCESS
});

export const addGoalToTemplateFailure = (error) => ({
    type: types.ADD_GOAL_TO_TEMPLATE_FAILURE,
    payload: error
});

export const updateTemplateGoal = (templateId, goalId, data) => ({
    type: types.UPDATE_TEMPLATE_GOAL,
    payload: { templateId, goalId, data }
});

export const updateTemplateGoalSuccess = () => ({
    type: types.UPDATE_TEMPLATE_GOAL_SUCCESS
});

export const updateTemplateGoalFailure = (error) => ({
    type: types.UPDATE_TEMPLATE_GOAL_FAILURE,
    payload: error
});

export const removeGoalFromTemplate = (templateId, goalId) => ({
    type: types.REMOVE_GOAL_FROM_TEMPLATE,
    payload: { templateId, goalId }
});

export const removeGoalFromTemplateSuccess = () => ({
    type: types.REMOVE_GOAL_FROM_TEMPLATE_SUCCESS
});

export const removeGoalFromTemplateFailure = (error) => ({
    type: types.REMOVE_GOAL_FROM_TEMPLATE_FAILURE,
    payload: error
});

// Dialog Actions
export const openTemplateDialog = (template = null) => ({
    type: types.OPEN_TEMPLATE_DIALOG,
    payload: template
});

export const closeTemplateDialog = () => ({
    type: types.CLOSE_TEMPLATE_DIALOG
});

export const openGoalDialog = (templateGoal = null) => ({
    type: types.OPEN_GOAL_DIALOG,
    payload: templateGoal
});

export const closeGoalDialog = () => ({
    type: types.CLOSE_GOAL_DIALOG
});

export const openManageGoalsDialog = (template) => ({
    type: types.OPEN_MANAGE_GOALS_DIALOG,
    payload: template
});

export const closeManageGoalsDialog = () => ({
    type: types.CLOSE_MANAGE_GOALS_DIALOG
});

export const openDeleteDialog = (template) => ({
    type: types.OPEN_DELETE_DIALOG,
    payload: template
});

export const closeDeleteDialog = () => ({
    type: types.CLOSE_DELETE_DIALOG
});

export const openDeleteGoalDialog = (goalId) => ({
    type: types.OPEN_DELETE_GOAL_DIALOG,
    payload: goalId
});

export const closeDeleteGoalDialog = () => ({
    type: types.CLOSE_DELETE_GOAL_DIALOG
});

// Filter and Pagination Actions
export const setFilters = (filters) => ({
    type: types.SET_FILTERS,
    payload: filters
});

export const setPagination = (pagination) => ({
    type: types.SET_PAGINATION,
    payload: pagination
});

export const setSort = (sort) => ({
    type: types.SET_SORT,
    payload: sort
});
